import axios, { AxiosRequestConfig } from "axios";
import { HsbModel, HsbProject } from "..";
import { HsbProjectsLoader } from "./hsb-projectsloader";
import { IProjectDB, NodeDataStorage } from './iproject-db';
import { DataStorageTable, IShareData } from "./isharedata";
import { IShareSessionBase } from './IShareSessionBase';

export class HsbModelAPIBackEndService {

  credentials: IShareSessionBase;
  baseurl: string;
  datastoreUrl: string = '/api/v2/efs/datastore';

  constructor(credentials: IShareSessionBase, baseurl: string) {
    this.credentials = credentials;
    this.baseurl = baseurl;
  }

  getFile(filepath: string): Promise<any> {
    let self = this;
    if (!this.credentials.token)
      return Promise.reject("HsbModelAPIBackEndService.getFile(): No proper token provided!")
    return new Promise(function (resolve, reject) {
      let config: AxiosRequestConfig<any> = {
        method: 'get',
        url: self.baseurl + self.datastoreUrl + '/getFile',
        responseType: 'json',
        params: {
          path: filepath
        },
        headers: {
          'x-access-token': self.credentials.token!,
          'content-type': 'application/json'
        }
      }
      axios(config).then(function (response) {
        if (response.data != null) {
          let metadata: any = {};
          metadata.filepath = filepath;
          metadata.data = response.data;
          resolve(metadata);
        }
      }).catch(function (error) {
        reject(error);
      })
    });
  }

  getFileUrlOLD(url: string): Promise<any> {
    let self = this;
    if (!this.credentials.token)
      return Promise.reject("HsbModelAPIBackEndService.getFileUrlOLD(): No proper token provided!")
    return new Promise(function (resolve, reject) {

      axios({
        method: 'get',
        url: url,
        headers: {
          'x-access-token': self.credentials.token!
        },
      }).then(function (response) {
        resolve(response.data);
      }).catch(function (error) {
        reject(error);
      })
    });
  }
  getFileUrl(url: string): Promise<any> {
    let self = this;
    return new Promise(function (resolve, reject) {
      axios.get(url, { responseType: "blob" })
        .then(function (response) {
          var reader = new FileReader();
          reader.readAsDataURL(response.data);
          reader.onload = function () {
            resolve(reader.result);
          }
        }).catch(function (error) {
          reject(error);
        })
    });
  }

  getCustomNodesWithContentArray(projectFolders: any, searchfiles: string | any[]): Promise<Array<any>> {
    let self = this;
    if (!this.credentials.token)
      return Promise.reject("HsbModelAPIBackEndService.getCustomNodesWithContentArray(): No proper token provided!")
    return new Promise(function (resolve, reject) {

      var pattern = '**/(';
      for (var x = 0; x < searchfiles.length; x++) {
        pattern += searchfiles[x].nodetype;
        if (x < searchfiles.length - 1) {
          pattern += '|';
        }
      }
      pattern += ')';

      axios({
        method: 'get',
        url: self.baseurl + self.datastoreUrl + '/downloadjsondata/array',
        params: { paths: projectFolders, pattern: pattern },
        headers: {
          'x-access-token': self.credentials.token!,
          'content-type': 'application/json'
        },
      }).then(function (foundfiles: any) {
        resolve(foundfiles);
      }).catch(function (error) {
        reject(error);
      })
    });
  }

  deleteIShareData(shareData: IShareData, nodemodel: { deleteNode: (arg0: any) => void; }, nodes: any[]): Promise<any> {
    let self = this;
    if (!this.credentials.token)
      return Promise.reject("HsbModelAPIBackEndService.deleteIShareData(): No proper token provided!")
    return new Promise(function (resolve, reject) {
      var nodeArray: any[] = [];

      if (!Array.isArray(nodes)) {
        nodeArray = [nodes];
      } else {
        nodeArray = nodes;
      }

      let nodeIds = nodeArray.map((node) => {
        if (node.pathid) {
          return node.pathid;
        } else if (node.data._id) {
          return node.data._id;
        }
      });

      if (nodeIds.length > 0) {

        axios({
          method: 'delete',
          url: self.baseurl + shareData.getStorageBaseUrl() + '/array',
          data: JSON.stringify({ nodeDataIds: nodeIds }),
          headers: {
            'x-access-token': self.credentials.token!,
            'content-type': 'application/json'
          },
        }).then(function (response: any) {
          if (nodemodel) {
            nodeArray.forEach(function (node) {
              nodemodel.deleteNode(node);
            });
          }
          return resolve(true);
        }).catch(function (error) {
          reject(error);
        });
      } else {
        return reject("No Node IDs provided");
      }
    });
  }

  deleteItemDataEFS(nodemodel: { deleteNode: (arg0: any) => void; }, nodedata: { pathid: any; }): Promise<any> {
    let self = this;
    if (!this.credentials.token)
      return Promise.reject("HsbModelAPIBackEndService.deleteItemDataEFS(): No proper token provided!")
    return new Promise(function (resolve, reject) {

      if (nodedata && nodedata.pathid) {

        axios({
          method: 'delete',
          url: self.baseurl + self.datastoreUrl + '/deleteitem',
          params: JSON.stringify({ path: nodedata.pathid }),
          headers: {
            'x-access-token': self.credentials.token!,
            'content-type': 'application/json'
          },
        }).then(function (response: any) {
          if (nodemodel) {
            nodemodel.deleteNode(nodedata);
          }
          return resolve(true);
        }).catch(function (error) {
          reject(error);
        });
      } else {
        return reject("HsbModelAPIBackEndService.deleteItemDataEFS(): No node data provided!");
      }
    });
  };


  deleteItemDataDB(nodemodel: { deleteNode: (arg0: any) => void; }, nodes: any[]): Promise<any> {

    let self = this;
    if (!this.credentials.token)
      return Promise.reject("HsbModelAPIBackEndService.deleteItemDataDB(): No proper token provided!")
    return new Promise(function (resolve, reject) {

      var nodeArray: any[] = [];

      if (!Array.isArray(nodes)) {
        nodeArray = [nodes];
      } else {
        nodeArray = nodes;
      }

      let nodeIds = nodeArray.map((node) => {

        if (node.pathid) {
          return node.pathid;
        } else if (node.data._id) {
          return node.data._id;
        }
      });

      if (nodeIds.length > 0) {

        axios({
          method: 'delete',
          url: self.baseurl + '/api/v3/node/data/array',
          data: JSON.stringify({ nodeDataIds: nodeIds }),
          headers: {
            'x-access-token': self.credentials.token!,
            'content-type': 'application/json'
          },
        }).then(function (response: any) {
          if (nodemodel) {

            nodeArray.forEach(function (node) {
              nodemodel.deleteNode(node);
            });
          }
          return resolve(true);
        }).catch(function (error) {
          reject(error);
        });
      } else {
        return reject("HsbModelAPIBackEndService.deleteItemDataDB(): No node IDs provided!");
      }
    });
  };

  deleteItemPath(path: any): Promise<any> {

    let self = this;
    if (!this.credentials.token)
      return Promise.reject("HsbModelAPIBackEndService.deleteItemPath(): No proper token provided!")
    var promise = new Promise(function (resolve, reject) {

      if (path) {
        axios({
          method: 'delete',
          url: self.baseurl + self.datastoreUrl + '/deleteitem',
          data: JSON.stringify({ path: path }),
          headers: {
            'x-access-token': self.credentials.token!,
            'content-type': 'application/json'
          },
        }).then(function (response: any) {
          return resolve(true);
        }).catch(function (error) {
          reject(error);
        });
      } else {
        return reject("HsbModelAPIBackEndService.deleteItemPath(): No path provided!");
      }
    });

    return promise;
  };

  addFiles(hsbProject: any, files: any[], folder: string): Promise<any> {

    let self = this;
    if (!this.credentials.token)
      return Promise.reject("HsbModelAPIBackEndService.addFiles(): No proper token provided!")
    var promise = new Promise(function (resolve, reject) {

      var formData = new FormData();
      if (files && files.length > 0) {

        files.forEach(function (fileData: { name: any; file: string | Blob; }) {

          if (!folder) {
            folder = '';
          }

          formData.append(folder + fileData.name, fileData.file);
        });

        axios({
          method: 'post',
          url: self.baseurl + self.datastoreUrl + '/addfiles',
          data: formData,
          headers: {
            'x-access-token': self.credentials.token!
          }
        }).then(function (response: any) {
          return resolve(response.data);
        }).catch(function (error) {
          reject(error);
        });
      } else {
        reject("NodeLoader::AddFiles(): No given files to upload!");
      }
    });

    return promise;
  }

  addFile(fileName: string, fileData: string | Blob, onProgressEvent?: (arg0: any) => void): Promise<any> {

    let self = this;
    if (!this.credentials.token)
      return Promise.reject("HsbModelAPIBackEndService.addFile(): No proper token provided!")
    return new Promise(function (resolve, reject) {

      var formData = new FormData();
      formData.append(fileName, fileData);

      if (fileName) {
        axios({
          method: 'post',
          url: self.baseurl + self.datastoreUrl + '/addfiles',
          data: formData,
          headers: {
            'x-access-token': self.credentials.token!
          },
          onUploadProgress: function (progressEvent) {
            if(onProgressEvent)
            onProgressEvent(progressEvent);
          }
        }).then(function (response: any) {
          return resolve(response.data);
        }).catch(function (error) {
          reject(error);
        });
      } else {
        reject("NodeLoader::AddFiles(): No given files to upload!");
      }
    });
  }

  makeFolder(path: any): Promise<any> {
    let self = this;
    if (!this.credentials.token)
      return Promise.reject("HsbModelAPIBackEndService.makeFolder(): No proper token provided!")
    return new Promise(function (resolve, reject) {

      if (path) {
        axios({
          method: 'post',
          url: self.baseurl + '/api/v2/efs/makedir',
          data: JSON.stringify({ path: path }),
          headers: {
            'x-access-token': self.credentials.token!,
            'content-type': 'application/json'
          },
        }).then(function (response: any) {
          return resolve(response.data);
        }).catch(function (error) {
          reject(error);
        });
      }
      else {
        reject("HsbModelAPIBackEndService.makeFolder(): No path provided");
      }
    });
  }


  copyFileorFolder(pathfrom: any, pathto: any): Promise<any> {
    let self = this;
    if (!this.credentials.token)
      return Promise.reject("HsbModelAPIBackEndService.copyFileorFolder(): No proper token provided!")
    return new Promise(function (resolve, reject) {

      if (pathfrom && pathto) {
        axios({
          method: 'put',
          url: self.baseurl + '/api/v2/efs/copy',
          data: JSON.stringify({ path: pathfrom, targetPath: pathto }),
          headers: {
            'x-access-token': self.credentials.token!,
            'content-type': 'application/json'
          },
        }).then(function (response: any) {
          return resolve(response.data);
        }).catch(function (error) {
          reject(error);
        });
      } else {
        reject("HsbModelAPIBackEndService.copyFileorFolder(): No paths provided!");
      }
    });
  };

  setNodeDataStorage(projectID: any, nodeDataStorage: NodeDataStorage): Promise<any> {
    let self = this;
    if (!this.credentials.token)
      return Promise.reject("HsbModelAPIBackEndService.setNodeDataStorage(): No proper token provided!")
    return new Promise(function (resolve, reject) {

      axios({
        method: 'put',
        url: self.baseurl + '/api/v3/user/admin/team/project/edit/node/data/storage',
        data: JSON.stringify({ projectID: projectID, nodeDataStorage: nodeDataStorage }),
        headers: {
          'x-access-token': self.credentials.token!,
          'content-type': 'application/json'
        },
      }).then(function (response: any) {
        return resolve(response.data);
      }).catch(function (error) {
        reject(error);
      });
    });
  }

  getCustomNodesWithContentArrayDB(tableIds: any, storageTable: DataStorageTable = DataStorageTable.Project): Promise<Array<any>> {
    let self = this;
    if (!this.credentials.token)
      return Promise.reject("HsbModelAPIBackEndService.getCustomNodesWithContentArrayDB(): No proper token provided!")
    return new Promise(function (resolve, reject) {

      let tableUrl = '/api/v4/node/data/array';
      let data = JSON.stringify({ paths: tableIds });
      if (storageTable == DataStorageTable.Team) {
        tableUrl = '/api/v4/team/node/data/array';
      } else if (storageTable == DataStorageTable.User) {
        tableUrl = '/api/v4/node/user/data/array';
        data = JSON.stringify({ userIds: tableIds });
      }

      axios({
        method: 'post',
        url: self.baseurl + tableUrl,
        data: data,
        headers: {
          'x-access-token': self.credentials.token!,
          'content-type': 'application/json'
        },
      }).then(function (response: any) {
        return resolve(response.data);
      }).catch(function (error) {
        reject(error);
      });
    });
  }

  addMetaFileDataDB(nodes: any, requestType: any, shareData: IShareData): Promise<any> {
    let self = this;
    if (!this.credentials.token)
      return Promise.reject("HsbModelAPIBackEndService.addMetaFileDataDB(): No proper token provided!")
    return new Promise(function (resolve, reject) {

      if (!nodes) reject('Invalid Data');
      var route = self.baseurl + shareData.getStorageBaseUrl();
      let nodeData = nodes;

      if (Array.isArray(nodes)) {
        route += '/array';
        nodeData = { nodeDataArray: nodes };
      }

      axios({
        method: requestType,
        url: route,
        data: JSON.stringify(nodeData),
        headers: {
          'x-access-token': self.credentials.token!,
          'content-type': 'application/json'
        },
      }).then(function (response: any) {
        return resolve(response.data);
      }).catch(function (error) {
        reject(error);
      });
    });
  }

  updateProjectModelNode(nodeData: any): Promise<any> {
    let self = this;
    if (!this.credentials.token)
      return Promise.reject("HsbModelAPIBackEndService.updateProjectModelNode(): No proper token provided!")
    return new Promise(function (resolve, reject) {

      axios({
        method: 'post',
        url: self.baseurl + '/api/v2/user/role/modelNode',
        data: JSON.stringify(nodeData),
        headers: {
          'x-access-token': self.credentials.token!,
          'content-type': 'application/json'
        },
      }).then(function (response: any) {
        return resolve(response.data);
      }).catch(function (error) {
        reject(error);
      });
    });
  }

  async getProjectModelNodes(projectID: string): Promise<any> {
    let self = this;
    if (!this.credentials.token)
      return Promise.reject("HsbModelAPIBackEndService.getProjectModelNodes(): No proper token provided!")
    try {
      return await axios.get(`${self.baseurl}/api/v4/pub/project/getMMProjects?projectId=${projectID}`,
        {
          responseType: 'json',
          headers: {
            'x-access-token': self.credentials.token!,
            'content-type': 'application/json'
          }
        })
    } catch (error) {
      return Promise.reject(error);
    }
  }

  /**
     * Notifies the abckend that the current user has opened a project.
     * @param projectId The ID of the project that was opened, (note: this is the project.projectID, not the node._id)
     * @returns Resolve if the activity was registered, reject otherwise
     */
  async registerActivityProjectOpened(projectId: string): Promise<any> {
    let self = this;
    if (!this.credentials.token)
      return Promise.reject("HsbModelAPIBackEndService.registerActivityProjectOpened(): No proper token provided!")
    try {
      return await axios.get(`${self.baseurl}/api/v1/register/opened/project/${projectId}`, {
        responseType: 'json',
        headers: {
          'x-access-token': self.credentials.token!,
          'content-type': 'application/json'
        }
      });
    }
    catch (error) {
      return Promise.reject(error);
    }
  }

  getProjects(includeArchived: boolean, getPublicProjects: boolean = false, getThumbnailDataUrl: boolean = false): Promise<any> {
    let self = this;
    if (!this.credentials.token)
      return Promise.reject("HsbModelAPIBackEndService.getProjects(): No proper token provided!")
    return new Promise(function (resolve, reject) {
      var datatype = 'json';

      axios({
        method: 'get',
        url: self.baseurl + `/api/v4/pub/project/getMMProjects?itemtype=projectinfo&archived=${includeArchived}&getPublic=${getPublicProjects}&getThumbnailDataUrl=${getThumbnailDataUrl}`,
        responseType: 'json',
        headers: {
          'x-access-token': self.credentials.token!,
          'content-type': 'application/json'
        },
      }).then(function (response: any) {
        resolve(response);
      }).catch(function (error) {
        reject(error);
      })
    });
  }
}
